// extracted by mini-css-extract-plugin
module.exports = {"divider":"menuBar_divider__V-Dq_","container":"menuBar_container__YCSwF"};